import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Icon from "./Icon";
import Access from "./Access";
import Modal from "./Modal";
import Form from "./Form";
import { message } from "../actions";
import Configuration from "../config";

export let ListElement = (
	{
		value,
		title = false,
		className = ""
	} ) =>
{
	let props = {};
	
	if ( title !== false )
	{
		props[ "title" ] = title;
	}
	
	return <div className={`field${className}`} {...props}>{value}</div>;
};

ListElement.propTypes = {
	value: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object, PropTypes.array ] ).isRequired,
	title: PropTypes.string,
	className: PropTypes.string
};

const mapStateToProps = ( state ) =>
{
	return {
		user: state.user,
		messages: state.messages
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class Overview extends React.Component
{
	constructor( props )
	{
		super( props );
		
		const { expanded = true } = { ...props };
		
		this.state = {
			list: [],
			sortedList: [],
			filter: "",
			listNeedUpdate: false,
			isExpand: [],
			arrowDropKeys: []
		};
		
		// Wenn die Übersicht eingeklappt werden darf, dann ist diese intial zu sehen
		if ( expanded )
		{
			this.state.isExpand[ props.title ] = true;
		}
		
		this.handleExpand = this.handleExpand.bind( this );
		this.handleFilterList = this.handleFilterList.bind( this );
		
	} // function constructor(...)
	
	/**
	 * Beim Erzeugen die Liste im State ablegen
	 */
	componentDidMount()
	{
		const { list = [], sortBy = false } = { ...this.props };
		
		// Wenn die List vorher sortiert werden soll.
		if ( sortBy !== false )
		{
			const name = sortBy.hasOwnProperty( "name" ) ? sortBy.name : sortBy;
			const type = sortBy.hasOwnProperty( "type" ) ? sortBy.type : "ASC";
			this.handleSort( name.toString(), type, 0, list );
		}
		else if ( Object.keys( list ).length > 0 )
		{
			this.setState( { list: list } );
		}
		
	} // function componentDidMount()
	
	/**
	 * Beim Seitenwechsel, Aktualisierung der Daten oder Filteraufruf den State aktualisieren
	 *
	 * @param {Object} a_prevProps Props
	 * @param {Object} a_prevState State
	 */
	componentDidUpdate( a_prevProps, a_prevState )
	{
		const { list = []/*, groupBy = false*/ } = { ...this.props };
		
		const state = {};
		
		/*// Wenn der Filter geschlossen wird, dann die Liste wiederherstellen
		 if ( !this.state.isExpand[ "overview_block_expand_filter" ] )
		 {
		 switch ( groupBy )
		 {
		 case "organization":
		 /!*if ( JSON.stringify( list ) !== JSON.stringify( this.state.list.values ) )
		 {
		 state[ "list" ] = this.state.sortedList;
		 }*!/
		 break;
		 default:
		 if ( JSON.stringify( list ) !== JSON.stringify( this.state.list ) )
		 {
		 state[ "list" ] = list;
		 }
		 break;
		 }
		 }*/
		
		if ( ( Object.keys( this.state.list ).length === 0 && this.state.filter.length === 0 )
			|| JSON.stringify( a_prevProps.list ) !== JSON.stringify( list ) )
		{
			state[ "list" ] = list;
			
			if ( this.state.listNeedUpdate )
			{
				this.handleFilterList( this.state.filter );
				state[ "listNeedUpdate" ] = false;
			}
		}
		
		if ( Object.keys( state ).length > 0 )
		{
			this.setState( state );
		}
		
	} // function componentDidMount()
	
	/**
	 * Formatiert einen Wert nach Typ
	 *
	 * @param {string} a_value Wert
	 * @param {string} a_format Zielformat
	 * @param {Object} a_options Formatoptionen
	 *
	 * @return {string}
	 */
	getFormatedValue( a_value, a_format, a_options )
	{
		switch ( a_format )
		{
			case "none":
				return a_value;
			case "price":
				return ( a_value && a_value > 0 ) || a_value.toString() === "0"
					? ( parseFloat( a_value.toString() ) ).toLocaleString( Configuration.location, Configuration.priceString ) + " Euro"
					: "-";
			case "date":
				return a_value && a_value.length > 0
					? new Date( a_value.toString() ).toLocaleString( Configuration.location, Configuration.dateString ) + " Uhr"
					: "";
			case "sex":
				switch ( a_value )
				{
					case "m":
						return "Herr";
					case "f":
						return "Frau";
					case "n":
					default:
						return "";
				}
			case "options":
				let optionValue = "";
				Object.keys( a_options ).forEach(
					a_key =>
					{
						const option = a_options[ a_key ];
						if ( option.value === a_value )
						{
							optionValue = option.title;
						}
					}
				);
				return optionValue;
			default:
				this.props.message( "Das übergebene Format wurde nicht erkannt.", "error" );
		}
		
	} // function getFormatedValue(...)
	
	/**
	 * Aktion: Elemente ausblenden oder angezeigen
	 *
	 * @param {string} a_id Elementkey
	 */
	handleExpand( a_id )
	{
		let isExpand = Object.assign(
			{},
			this.state.isExpand,
			{
				[ a_id ]: !this.state.isExpand[ a_id ]
			}
		);
		
		this.setState( { isExpand: isExpand } );
		
	} // function handleExpand(...)
	
	/**
	 * Aktion: Liste nach Suchbegriff filtern
	 *
	 * @param {string} a_search Suchbegriff
	 */
	handleFilterList( a_search )
	{
		const { list } = { ...this.props };
		
		if ( list && Object.keys( list ).length > 0 )
		{
			const state = {
				filter: a_search
			};
			if ( a_search && a_search.length > 0 )
			{
				let filteredList = {};
				
				if ( a_search.search( "," ) )
				{
					a_search.split( "," ).map( search => Object.assign( filteredList, this.getFilteredList( search.trim() ) ) );
				}
				else
				{
					this.getFilteredList( a_search );
				}
				state[ "list" ] = filteredList;
			}
			else
			{
				state[ "list" ] = this.state.sortedList;
			}
			
			this.setState( state );
		}
		
	} // function handleFilterList(...)
	
	/**
	 * Gibt die gefilterte Liste zurück
	 *
	 * @param {string} a_search Suchbegriff
	 *
	 * @return {array}
	 */
	getFilteredList( a_search )
	{
		const { list, groupBy = false, sortBy = false } = { ...this.props };
		const filteredList = [];
		
		if ( groupBy && sortBy !== false )
		{
			Object.keys( this.state.sortedList ).forEach(
				a_key =>
				{
					const organizationList = this.state.sortedList[ a_key ];
					filteredList[ a_key ] = {};
					filteredList[ a_key ][ "organization" ] = organizationList.organization;
					filteredList[ a_key ][ "values" ] = [];
					
					Object.keys( organizationList.values ).forEach(
						a_rawKey =>
						{
							const raw = organizationList.values[ a_rawKey ];
							
							if ( Object.keys( raw ).map( i => raw[ i ] ).join( " " ).toLowerCase().search( a_search.toLowerCase() ) !== -1 )
							{
								filteredList[ a_key ][ "values" ][ a_rawKey ] = raw;
							}
						}
					);
				}
			);
			
			return filteredList;
		}
		
		Object.keys( list ).forEach(
			a_key =>
			{
				if ( Object.keys( list[ a_key ] ).map( i => list[ a_key ][ i ] ).join( " " ).toLowerCase().search( a_search.toLowerCase() ) !== -1 )
				{
					filteredList[ a_key ] = list[ a_key ];
				}
			}
		);
		
		return filteredList;
		
	} // function getFilteredList(...)
	
	/**
	 * Zeile formatieren und als HTML zurück geben
	 *
	 * @param {Object} a_element Listenelement
	 * @param {string|Object} a_name Elementname
	 * @param {string} a_format Zielformat
	 * @param {string|Object} a_className Klassennamen
	 * @param {Object} a_options Formatoptionen
	 *
	 * @return {html}
	 */
	renderValue( a_element, a_name, a_format, a_className, a_options )
	{
		return typeof a_name === "object"
			
			? Object.keys( a_name ).map(
				i =>
				{
					return typeof a_name[ i ] === "object"
						? <div key={`field_outer_block_${a_name[ i ]}`}>
							{this.renderValue( a_element, a_name[ i ], a_format, a_className ? a_className[ i ] : undefined )}
						</div>
						: <span key={`field_inner_block_${a_name[ i ]}`} className={`blank${typeof a_className === "object" ? " " + a_className[ i ] : " " + a_className}`}>
							{this.getFormatedValue( a_element[ a_name[ i ] ], a_format, a_options )}
						</span>;
					
				} )
			
			: a_element[ a_name ] === 0
				? this.getFormatedValue( "0", a_format, a_options ) : a_element[ a_name ]
					? this.getFormatedValue( a_element[ a_name ], a_format, a_options ) : "";
		
	} // function renderValue(...)
	
	/**
	 * Aktion: Sortiere die Liste
	 *
	 * @param {string} a_name Feldname
	 * @param {string} a_type Feldtyp
	 * @param {number} a_currentGroupId Aktionselement Id (Optional)
	 * @param {Object} a_list Elemente die Sortiert werden sollen (Optional)
	 */
	handleSort( a_name, a_type, a_currentGroupId = 0, a_list = [] )
	{
		const list = a_list.length > 0 ? a_list : this.state.list;
		let sortedListKeys = [];
		const state = {};
		
		switch ( this.props.groupBy )
		{
			// Liste nach der Gruppe sortieren
			case "organization":
				const groupedList = a_list.length > 0 ? [] : this.state.list;
				const arrowDropKeys = a_currentGroupId > 0
					? this.state.arrowDropKeys.filter( a_dropKey => a_dropKey.split( "__" )[ 0 ] !== a_currentGroupId )
					: this.state.arrowDropKeys;
				
				if ( a_currentGroupId > 0 )
				{
					arrowDropKeys.push( `${a_currentGroupId}__${a_type}__${a_name}` );
				}
				
				a_list.length > 0 && Object.keys( list ).forEach(
					( a_key ) =>
					{
						const element = list[ a_key ];
						if ( !groupedList.hasOwnProperty( element.organization_name ) )
						{
							groupedList[ element.organization_name ] = { organization: element.organization, values: [] };
						}
						groupedList[ element.organization_name ].values.push( element );
					}
				);
				
				sortedListKeys = a_list.length > 1 ? Object.keys( groupedList ).sort() : Object.keys( groupedList );
				state[ "list" ] = Object.keys( sortedListKeys ).map(
					a_key =>
					{
						const group = groupedList[ sortedListKeys[ a_key ] ];
						if ( group.organization.id === a_currentGroupId )
						{
							const sortedValueKeys = a_type === "ASC"
								? Object.keys( group.values ).sort( ( a_key1, a_key2 ) =>
									( group.values[ a_key1 ][ a_name ] ? group.values[ a_key1 ][ a_name ].toLowerCase() : "" ) < ( group.values[ a_key2 ][ a_name ] ? group.values[ a_key2 ][ a_name ].toLowerCase() : "" ) ? -1 : 1 )
								: Object.keys( group.values ).sort( ( a_key1, a_key2 ) =>
									( group.values[ a_key1 ][ a_name ] ? group.values[ a_key1 ][ a_name ].toLowerCase() : "" ) > ( group.values[ a_key2 ][ a_name ] ? group.values[ a_key2 ][ a_name ].toLowerCase() : "" ) ? -1 : 1 );
							group.values = sortedValueKeys.map( a_key => group.values[ a_key ] );
						}
						
						// Initial die Keys setzen
						if ( a_list.length > 0 )
						{
							const dropKey = `${group.organization.id}__${a_type}__${a_name}`;
							if ( arrowDropKeys.indexOf( dropKey ) === -1 )
							{
								arrowDropKeys.push( dropKey );
							}
						}
						
						return group;
					}
				);
				
				state[ "arrowDropKeys" ] = arrowDropKeys;
				break;
			
			// Liste vollständig sortieren
			default:
				sortedListKeys = a_type === "ASC"
					? Object.keys( list ).sort( ( a_key1, a_key2 ) =>
						( list[ a_key1 ][ a_name ] ? list[ a_key1 ][ a_name ].toLowerCase() : "" ) < ( list[ a_key2 ][ a_name ] ? list[ a_key2 ][ a_name ].toLowerCase() : "" ) ? -1 : 1 )
					: Object.keys( list ).sort( ( a_key1, a_key2 ) =>
						( list[ a_key1 ][ a_name ] ? list[ a_key1 ][ a_name ].toLowerCase() : "" ) > ( list[ a_key2 ][ a_name ] ? list[ a_key2 ][ a_name ].toLowerCase() : "" ) ? -1 : 1 );
				state[ "arrowDropKeys" ] = [ `${a_type}__${a_name}` ];
				state[ "list" ] = sortedListKeys.map( a_key => list[ a_key ] );
				break;
		}
		state[ "sortedList" ] = state[ "list" ];
		
		this.setState( state );
		
	} // function handleSort(...)
	
	/**
	 * Aktion: Triggerfunktionen ausführen
	 *
	 * @param {function} a_dispatch Triggerfunktion
	 * @param {Object} a_old_values Vorherige Werte
	 * @param {string} a_form_ref Referenzkey der Form
	 *
	 * @return {function}
	 */
	handleSubmitForm( a_dispatch, a_old_values, a_form_ref )
	{
		if ( this.refs.hasOwnProperty( a_form_ref ) )
		{
			this.setState( { listNeedUpdate: true } );
			
			return a_dispatch( a_old_values, this.refs[ a_form_ref ].state );
		}
		
	} // function handleSubmitForm(...)
	
	/**
	 * Aktion: Modal oder Aktion hinter der Triggeraktion öffnen
	 *
	 * @param {function} a_dispatch Triggerfunktion
	 * @param {Object} a_values Aktuelle Werte
	 *
	 * @return {function}
	 */
	handleSubmit( a_dispatch, a_values )
	{
		this.setState( { listNeedUpdate: true } );
		
		return a_dispatch( a_values );
		
	} // function handleSubmit(...)
	
	renderRaw( a_element, a_key, a_header, a_label, a_expandKey )
	{
		const { listFields = {}, trigger, groupLabel = true, classNameItem = "", classNameDataBlock = "", classNameTriggerBlock = "" } = { ...this.props };
		
		return [
			a_header,
			( a_expandKey === false || this.state.isExpand[ a_expandKey ] ) &&
			[
				a_label,
				<li className={`collection-item ${classNameItem}`} key={`overview_collection_item_${a_key}`}>
					<div className={classNameDataBlock}>
						{
							// Anhand der Feldoptionen die Werte ausgeben
							Object.keys( listFields ).map(
								a_name =>
								{
									const {
										className,
										fieldValueClassName,
										title,
										name,
										sortable = false,
										cleared = false,
										hideOnEmpty = false,
										removeOnEmpty = false,
										permissions = false,
										format = "none",
										options = {}
									} = { ...listFields[ a_name ] };
									
									const fieldName = typeof name === "object" ? name[ 0 ] : name;
									const permissionsToShow = permissions ? permissions : this.props.permissionsToShow;
									
									// Verstecke das Feld wenn es gewünscht ist und leer ist
									const hidden = hideOnEmpty && a_element[ name ] === null;
									const removed = removeOnEmpty && a_element[ name ] === null;
									
									// Titel zum Objekt umwandeln
									const fieldTitle = typeof title === "object" ? title : [ title ];
									
									return !removed &&
										<Access key={`overview_element_${fieldName}_${a_key}`} permissions={permissionsToShow}>
											<div key={`overview_collection_values_${fieldName}_${a_key}`} className={className}>
												{
													!hidden && Object.keys( fieldTitle ).map(
														a_key =>
														{
															const fieldType = typeof title === "object" ? name[ a_key ] : name;
															const props = {};
															
															if ( typeof fieldType !== "object" )
															{
																props[ "className" ] = typeof fieldValueClassName === "object"
																	? fieldValueClassName[ a_key ]
																	: fieldValueClassName;
															}
															const sortType = this.state.arrowDropKeys.length > 0 && this.state.arrowDropKeys[ 0 ].split( "__" )[ 0 ] === "ASC" ? "DESC" : "ASC";
															
															return <React.Fragment key={`label_overview_element_${a_key}`}>
																{
																	// Sortierfunktionalität
																	!groupLabel
																		? Object.keys( this.state.list ).length > 1
																		? <label className={"pointer unsetTextSelect"}
																		         onClick={() => this.handleSort( fieldType, sortType )}>
																			{fieldTitle[ a_key ]}
																			{
																				// Sortierung nicht für Zusammengefasste Elemente (Außnahme mit getrennten Titeln)
																				( typeof name !== "object" || typeof title === "object" ) &&
																				typeof sortable === "object" ? sortable[ a_key ] : sortable &&
																					<span className={"actions margin-left"}>
																					<span className={"btn btn-flat hover-transparent"}
																					      onClick={() => this.handleSort( fieldType, "DESC" )}>
																						<Icon size={7} iconName={"moveUp"}/>
																					</span>
																					<span className={"btn btn-flat hover-transparent"}
																					      onClick={() => this.handleSort( fieldType, "ASC" )}>
																						<Icon size={7} iconName={"moveDown"}/>
																					</span>
																				</span>
																			}
																		</label>
																		: <label>{fieldTitle[ a_key ]}</label>
																		: null
																}
																<ListElement {...props}
																             title={fieldTitle[ a_key ]}
																             value={this.renderValue(
																	             a_element,
																	             fieldType,
																	             format,
																	             fieldValueClassName,
																	             options
																             )}/>
															</React.Fragment>;
														}
													)
												}
											</div>
											{
												cleared &&
												<div key={`overview_collection_cleared_${fieldName}_${a_key}`} className={"cleared"}/>
											}
										</Access>;
								}
							)
							
						}
					</div>
					<div className={classNameTriggerBlock}>
						{
							// Aktionsbuttons rendern
							Object.keys( trigger ).map(
								i =>
								{
									const triggerElement = trigger[ i ];
									let iconName = "";
									let iconNameModal = "";
									let iconClassName = "";
									let iconTitle = "";
									
									let title = "";
									let key = "";
									let submitButtonText = "Speichern";
									let cancelButtonText = "Abbrechen";
									let submitText = "";
									
									let confirm = triggerElement.hasOwnProperty( "confirm" ) ? triggerElement.confirm : true;
									
									// Array Elemente darstellen
									if ( triggerElement.fieldName && typeof triggerElement.fieldName === "object" )
									{
										const result = a_element[ triggerElement.fieldName.key ].toString() !== triggerElement.fieldName.value.toString();
										
										iconName = typeof triggerElement.icon === "object"
											? result ? triggerElement.icon[ 0 ] : triggerElement.icon[ 1 ]
											: triggerElement.icon;
										
										iconNameModal = typeof triggerElement.icon === "object"
											? !result ? triggerElement.icon[ 0 ] : triggerElement.icon[ 1 ]
											: triggerElement.icon;
										
										iconClassName = typeof triggerElement.iconClassName === "object"
											? result ? triggerElement.iconClassName[ 0 ] : triggerElement.iconClassName[ 1 ]
											: triggerElement.iconClassName;
										
										iconTitle = typeof triggerElement.iconTitle === "object"
											? result ? triggerElement.iconTitle[ 0 ] : triggerElement.iconTitle[ 1 ]
											: triggerElement.iconTitle;
										
										key = typeof triggerElement.key === "object"
											? result ? triggerElement.key[ 0 ] : triggerElement.key[ 1 ]
											: triggerElement.key;
										
										submitButtonText = triggerElement.submitButtonText && typeof triggerElement.submitButtonText === "object"
											? result ? triggerElement.submitButtonText[ 0 ] : triggerElement.submitButtonText[ 1 ]
											: triggerElement.submitButtonText ? triggerElement.submitButtonText : submitButtonText;
										
										cancelButtonText = triggerElement.cancelButtonText && typeof triggerElement.cancelButtonText === "object"
											? result ? triggerElement.cancelButtonText[ 0 ] : triggerElement.cancelButtonText[ 1 ]
											: triggerElement.cancelButtonText ? triggerElement.cancelButtonText : cancelButtonText;
										
										submitText = triggerElement.submitText && typeof triggerElement.submitText === "object"
											? result ? triggerElement.submitText[ 0 ] : triggerElement.submitText[ 1 ]
											: triggerElement.submitText ? triggerElement.submitText : submitText;
									}
									// String Elemente
									else
									{
										iconNameModal = iconName = triggerElement.icon ? triggerElement.icon : iconNameModal;
										iconClassName = triggerElement.iconClassName ? triggerElement.iconClassName : iconClassName;
										iconTitle = triggerElement.iconTitle ? triggerElement.iconTitle : iconTitle;
										title = triggerElement.title ? triggerElement.title : title;
										
										key = triggerElement.key ? triggerElement.key : "";
										submitButtonText = triggerElement.submitButtonText ? triggerElement.submitButtonText : submitButtonText;
										cancelButtonText = triggerElement.cancelButtonText ? triggerElement.cancelButtonText : cancelButtonText;
										submitText = triggerElement.submitText ? triggerElement.submitText : submitText;
									}
									
									// Deaktiviere den Aktionsbutton wenn das Feld leer ist, oder der Wert übereinstimmt, oder einen Wert enthält
									let disabled = ( triggerElement.disableOnEmpty && !a_element[ triggerElement.disableOnEmpty ] )
										|| ( triggerElement.disableOnNotEmpty && a_element[ triggerElement.disableOnNotEmpty ] )
										|| ( triggerElement.disableOnValue && a_element[ triggerElement.disableOnValue.key ] && a_element[ triggerElement.disableOnValue.key ].toString() === triggerElement.disableOnValue.value.toString() )
										|| ( triggerElement.disableOnSubstring && a_element[ triggerElement.disableOnSubstring.key ] && a_element[ triggerElement.disableOnSubstring.key ].indexOf( triggerElement.disableOnSubstring.value ) !== -1 );
									if ( !disabled && triggerElement.disableOnValues && a_element[ triggerElement.disableOnValues.key ] )
									{
										Object.keys( triggerElement.disableOnValues.values ).every(
											a_key =>
											{
												const value = triggerElement.disableOnValues.values[ a_key ];
												
												if ( a_element[ triggerElement.disableOnValues.key ].toString() === value.toString() )
												{
													disabled = true;
													
													return false;
												}
												
												return true;
											}
										);
									}
									
									// Aktion mit dem Modaldialog bestätigen
									if ( confirm )
									{
										return <Access key={`overview_trigger_${i}`} permissions={triggerElement.permissions}>
											{
												// Deaktivierte Aktion
												disabled
													? <button title={iconTitle} className={`btn btn-middle icon-shadow ${iconClassName}`} disabled>
														<Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
													</button>
													
													// Nur die Aktion ausführen
													: triggerElement.onlyActionButton
													? <button title={iconTitle} className={`btn btn-middle icon-shadow ${iconClassName}`}
													          onClick={() => this.handleSubmit( triggerElement.onClick, a_element )}>
														<Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
													</button>
													
													// Modal mit einer benutzerdefinierten Form
													: triggerElement.formFields
														? <Form
															id={`formEdit_${key}_modal_${a_key}`}
															ref={`formEdit_${key}_modal_${a_key}`}
															
															modalTitle={title}
															modalClass={"confirm tLeft"}
															modalTrigger={
																<button title={iconTitle} className={`btn btn-middle icon-shadow ${iconClassName}`}>
																	<Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
																</button>
															}
															additionalModalHtml={triggerElement.additionalModalHtml}
															
															errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
															onSubmit={() => this.handleSubmitForm( triggerElement.onClick, a_element, `formEdit_${key}_modal_${a_key}` )}
															submitValue={[
																<Icon size={14} key={`form-edit-icon`} iconName={iconNameModal}/>,
																<span key={`form-edit-text`}>{submitButtonText}</span>
															]}
															// Felder auf die Berechtigung überprüfen
															fields={triggerElement.formFields.filter( a_key => !a_key.permissions || Access.isPermitted( this.props.user, a_key.permissions, true ) )}
															values={a_element}
															
															additionalFormHtml={triggerElement.additionalFormHtml}
														/>
														
														// Modal mit Text
														: <Modal className={"confirm tLeft"}
														         key={`overview_${key}_modal_${a_key}`}
														         title={title}
														
														         trigger={
															         <button title={iconTitle} className={`btn btn-middle icon-shadow ${iconClassName}`}>
																         <Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
															         </button>
														         }
														         additionalModalHtml={triggerElement.additionalModalHtml}
														
														         footer={
															         <React.Fragment>
																         <button onClick={() => this.handleSubmit( triggerElement.onClick, a_element )}
																                 data-modal={"confirm"}>
																	         <Icon size={14} iconName={iconNameModal}/><span>{submitButtonText}</span>
																         </button>
																         <button className={"secondary-color"} data-modal={"close"}>
																	         <Icon iconName={"discard"}/><span>{cancelButtonText}</span>
																         </button>
															         </React.Fragment>
														         }
														>
															{
																typeof submitText === "object"
																	? submitText
																	: <p className={"tLeft"}>{submitText}</p>
															}
														</Modal>
											}
										</Access>;
									}
									else
									{
										return <Access key={`overview_trigger_${i}`} permissions={triggerElement.permissions}>
											{
												// Deaktivierte Aktion
												disabled
													? <button title={iconTitle} className={`btn btn-middle icon-shadow ${iconClassName}`} disabled>
														<Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
													</button>
													
													// einfache Aktion
													: <button onClick={() => this.handleSubmit( triggerElement.onClick, a_element )}
													          title={iconTitle}
													          className={`btn btn-middle icon-shadow ${iconClassName}`}>
														<Icon verticalAlign={"middle"} size={18} iconName={iconName}/>
													</button>
											}
										</Access>;
									}
								}
							)
						}
					</div>
				</li>
			]
		];
	}
	
	renderLabel( a_key, a_currentGroupId )
	{
		const { listFields = {}, groupBy = false, classNameDataBlock = "", classNameTriggerBlock = "" } = { ...this.props };
		
		// Überschriften ausgeben
		return <li key={`overview_label_${a_key}`} className={"collection-item item-spacer labelSpacer light-grey"}>
			<div className={classNameDataBlock}>
				{
					// Anhand der Feldoptionen die Werte ausgeben
					Object.keys( listFields ).map(
						a_name =>
						{
							const {
								className,
								fieldValueClassName,
								title,
								name,
								sortable = false,
								permissions = false
							} = { ...listFields[ a_name ] };
							
							const fieldName = typeof name === "object" ? name[ 0 ] : name;
							const permissionsToShow = permissions ? permissions : this.props.permissionsToShow;
							
							// Titel zum Objekt umwandeln
							const fieldTitle = typeof title === "object" ? title : [ title ];
							
							return <Access key={`overview_element_lable_${fieldName}_${a_key}`} permissions={permissionsToShow}>
								<div className={`relative ${className}`}>
									{
										Object.keys( fieldTitle ).map(
											a_key =>
											{
												const fieldType = typeof title === "object" ? name[ a_key ] : name;
												const props = {};
												
												if ( typeof fieldType !== "object" )
												{
													props[ "className" ] = typeof fieldValueClassName === "object"
														? fieldValueClassName[ a_key ]
														: fieldValueClassName;
												}
												
												const arrowDropUpKey = groupBy !== false
													? `${a_currentGroupId}__DESC__${fieldName}`
													: `DESC__${fieldName}`;
												const arrowDropDownKey = groupBy !== false
													? `${a_currentGroupId}__ASC__${fieldName}`
													: `ASC__${fieldName}`;
												const arrowDropUp = this.state.arrowDropKeys.indexOf( arrowDropUpKey ) >= 0
													? " selected"
													: "";
												const arrowDropDown = this.state.arrowDropKeys.indexOf( arrowDropDownKey ) >= 0
													? " selected"
													: "";
												const sortType = arrowDropDown === " selected" ? "DESC" : "ASC";
												
												return <React.Fragment key={`collection_label_${a_key}`}>
													{
														// Sortierung nicht für Zusammengefasste Elemente (Außnahme mit getrennten Titeln)
														( typeof name !== "object" || typeof title === "object" ) &&
														typeof sortable === "object" ? sortable[ a_key ] : sortable &&
														Object.keys( this.state.list ).length > 1
															? <React.Fragment>
																<label className={"pointer unsetTextSelect"}
																       onClick={() => this.handleSort( fieldType, sortType, a_currentGroupId )}>
																	{fieldTitle[ a_key ]}
																</label>
																<span className={"label-actions"}>
																<span className={`btn btn-flat hover-white${arrowDropUp}`}
																      onClick={() => this.handleSort( fieldType, "DESC", a_currentGroupId )}>
																	<Icon size={7} iconName={"moveUp"}/>
																</span>
																<span className={`btn btn-flat hover-white${arrowDropDown}`}
																      onClick={() => this.handleSort( fieldType, "ASC", a_currentGroupId )}>
																	<Icon size={7} iconName={"moveDown"}/>
																</span>
															</span>
															</React.Fragment>
															: <label>{fieldTitle[ a_key ]}</label>
													}
												</React.Fragment>;
											}
										)
									}
								</div>
							</Access>;
						}
					)
				}
			</div>
			<div className={classNameTriggerBlock}><label>Aktionen</label></div>
		</li>;
	}
	
	render()
	{
		const { list = [], title = "", subTitle = "", titleColor = "primary-color", permissionsToShow = [], groupBy = false, groupLabel = true, className = "" } = { ...this.props };
		const listLength = Object.keys( list ).length;
		let currentListLength = 0;
		if ( groupBy )
		{
			Object.keys( this.state.list ).forEach( a_groupKey =>
				Object.keys( this.state.list[ a_groupKey ] ).forEach( a_field =>
					{
						if ( a_field === "values" )
						{
							currentListLength += this.state.list[ a_groupKey ][ a_field ].length;
						}
					}
				)
			);
		}
		else
		{
			currentListLength = Object.keys( this.state.list ).length;
		}
		let currentGroupId;
		let hasLabel = false;
		
		const titleProps = { className: "unsetTextSelect" };
		if ( listLength > 1 )
		{
			titleProps[ "onClick" ] = () => this.handleExpand( title );
			titleProps[ "className" ] = "pointer unsetTextSelect";
		}
		
		// Liste darstellen wenn Daten vorliegen
		return listLength > 0 && <Access permissions={permissionsToShow}>
			<ul key={`overview_list_${title}`} className={`collection collection-block with-header${groupLabel ? " groupedLabel" : ""} ${className}`}>
				<li key={`overview_header_${title}`} className={`collection-item collection-item-spacer item-spacer white-text ${titleColor}`}>
					<div className="actions actions-right">
						{
							// Button für das Ein-/Ausklappen des Filtermenüs
							listLength > 1 &&
							<button className={`btn btn-small btn-flat hover-transparent right ${this.state.filter.length > 0 ? "red-text" : "white-text"}`}
							        onClick={() => this.handleExpand( "overview_block_expand_filter" )}>
								<Icon title={"Filtern"} iconName={"filter"}/>
							</button>
						}
					</div>
					<h6 {...titleProps}>
						{title} {subTitle} {listLength > 1 && <Icon verticalAlign={"top"} size={12} iconName={this.state.isExpand[ title ] ? "hide" : "show"}/>}
					</h6>
				</li>
				{
					// Filtermenü
					this.state.isExpand[ "overview_block_expand_filter" ] &&
					<li key={`overview_filter_header_${title}`} className={"collection-header secondary-color optionsHeader"}>
						<div className={"col s12 m8 l6 xl4"}>
							<label className={"white-text"}>
								Filter <span className={"right"}>{`${title}: ${currentListLength} von ${listLength}`}</span>
							</label>
							<input className={"unset-margin white-text"} type={"text"} placeholder={"1. Suchbegriff, 2. Suchbegriff, ..."} value={this.state.filter}
							       onChange={event => this.handleFilterList( event.target.value )}/>
						</div>
					</li>
				}
				{
					// Listenelemente rendern
					this.state.isExpand[ title ]
						? currentListLength > 0 &&
						Object.keys( this.state.list ).map(
							( a_key ) =>
							{
								const element = this.state.list[ a_key ];
								let header, label, expandKey;
								
								// Wenn Gruppiert werden soll
								if ( groupBy !== false )
								{
									// Kopfdaten ausgeben
									switch ( groupBy )
									{
										case "organization":
											return Object.keys( element ).map(
												a_key =>
												{
													if ( a_key === "organization" )
													{
														const organization = element[ a_key ];
														expandKey = `organization_${organization.id}`;
														// hasLabel = !( organization && organization.id !== currentGroupId );
														hasLabel = false;
														currentGroupId = organization.id;
														
														header = <li key={`overview_${expandKey}`}
														             className={"collection-item organizationSpacer item-spacer middle-grey pointer"}
														             onClick={() => this.handleExpand( expandKey )}>
															<div className="actions actions-right">
																<button className="btn btn-small btn-flat hover-transparent right"
																        key={`block_expand_id_${organization.id}`}>
																	<Icon size={15} iconName={this.state.isExpand[ expandKey ] ? "hide" : "show"}/>
																</button>
															</div>
															{organization.name}<br/>
															<label className={"label-grey-text"}>
																{`${organization.street} ${organization.street_number}, ${organization.postal_code} ${organization.city}`}
															</label>
														</li>;
													}
													else if ( a_key === "values" )
													{
														if ( groupLabel && !hasLabel && element[ a_key ].length > 0 )
														{
															hasLabel = true;
															label = this.renderLabel( a_key, currentGroupId );
														}
														return Object.keys( element[ a_key ] ).map(
															key =>
															{
																const raw = this.renderRaw( element[ a_key ][ key ], key, header, label, expandKey );
																header = null;
																label = null;
																
																return raw;
															}
														);
													}
													
													return <React.Fragment key={`overview_empty_${expandKey ? expandKey : a_key}`}/>;
												}
											);
										
										default:
											// Die Gruppe ist nicht bekannt
											return <React.Fragment key={`overview_empty_${a_key}`}/>;
									}
								}
								else
								{
									if ( groupLabel && !hasLabel )
									{
										hasLabel = true;
										label = this.renderLabel( a_key, currentGroupId );
									}
									return this.renderRaw( element, a_key, null, label, false );
								}
							}
						)
						: <li key={`overview_filter_footer_${title}`} className={"collection-item white-grey"}>
							<div className={"col s12"}>
								{listLength} {listLength === 1
								? `${title} ist `
								: `${title} sind `} ausgeblendet.
							</div>
						</li>
				}
			</ul>
		</Access>;
		
	} // function render()
	
} // class

Overview = connect(
	mapStateToProps,
	mapDispatchToProps
)( Overview );

Overview.propTypes = {
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string,
	titleColor: PropTypes.string,
	list: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] ).isRequired,
	listFields: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] ).isRequired,
	trigger: PropTypes.oneOfType( [ PropTypes.array, PropTypes.object ] ),
	permissionsToShow: PropTypes.array.isRequired,
	expanded: PropTypes.bool,
	groupBy: PropTypes.string,
	sortBy: PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ),
	groupLabel: PropTypes.bool,
	className: PropTypes.string,
	classNameItem: PropTypes.string,
	classNameDataBlock: PropTypes.string,
	classNameTriggerBlock: PropTypes.string
};

export default Overview;